export default __webpack_public_path__ + "media/images/features/local_delivery/otetsutabi-f48a9f83f8579e8f4217173a1e9c99db.png";